import React, { Component } from 'react';
import { Input, Select, DatePicker, Icon } from 'antd';
import store from '../../../store';
import { setSearchParams } from '../../../actions/executeActions';
import TemplateTree from './TemplateTree';
import moment from 'moment';
import '../style/list.less';

const Option = Select.Option;
const { RangePicker } = DatePicker;

class TemplateSearch extends Component {

    constructor(props) {
        super(props);
        const { searchItem } = props;
        const { followBoardDetailId, moduleDefineCode, moduleDefineName, criteriaDataType, projectDefineWebType, moduleDefineConstraintValue } = searchItem;
        this.state = {
            followBoardDetailId,
            moduleDefineCode,
            moduleDefineName,
            criteriaDataType,
            projectDefineWebType,
            moduleDefineConstraintValue,
            searchValue: '',
            templateType: {},
        };
    }

    showTemplateTree = () => {
        const { followBoardDetailId, templateType } = this.state;
        const { optionName } = templateType;
        this.TemplateTreeRef.show(followBoardDetailId, optionName);
    }

    saveTemplateData = params => {
        this.setState({
            searchValue: params.optionId,
            templateType: { ...params },
        }, () => {
            this.setSearchParams();
        });
    }

    clearTemplateType = () => {
        this.setState({
            searchValue: '',
            templateType: {},
        }, () => {
            this.setSearchParams();
        });
    }

    handleInputChange = e => {
        this.setState({ searchValue: e.target.value }, () => {
            this.setSearchParams();
        });
    }

    handleDatePickerChange = (date, dateString) => {
        if(dateString[0] == "" && dateString[1] == ""){
            dateString = '';
        }
        this.setState({
            searchValue: dateString,
        }, () => {
            this.setSearchParams();
        });
    }

    handleSelectChange = value => {
        this.setState({ searchValue: value }, () => {
            this.setSearchParams();
        });
    }

    handleBlur = () => {
        this.setSearchParams();
    }

    setSearchParams = () => {
        const { moduleDefineCode } = this.state;
        store.dispatch(setSearchParams(moduleDefineCode, { ...this.state }));
    }

    getOwnState = () => {
        if(store.getState()){
            if(store.getState().executeState){
                if(store.getState().executeState.searchParams){
                    if(store.getState().executeState.searchParams[this.state.moduleDefineCode]){
                        return {
                            searchValue: store.getState().executeState.searchParams[this.state.moduleDefineCode]['searchValue']
                        }
                    }
                }
            }
        }
        return null;  
    }

    onStoreChange = () => {
        if (this.getOwnState()) {
            this.setState(this.getOwnState());
        } else {
            this.setState({ searchValue: '' });
        }
    }

    componentDidMount= () => {
        store.subscribe(this.onStoreChange);
    }

    componentWillUnmount = () => {
        store.subscribe(this.onStoreChange);
        const { moduleDefineCode } = this.state;
        store.dispatch(setSearchParams(moduleDefineCode, {}));
    }

    getDom = () => {
        const {
            moduleDefineName,
            projectDefineWebType,
            moduleDefineConstraintValue = '',
            searchValue,
            templateType,
        } = this.state;
        if (projectDefineWebType === 'INPUT' || projectDefineWebType === 'TEXTAREA' || projectDefineWebType === 'INPUTNUMBER') {
            return (
                <Input
                    className="ui-input"
                    placeholder={`请输入`}
                    value={searchValue}
                    onChange={this.handleInputChange}
                    onBlur={this.handleBlur}
                />
            )
        } else if (projectDefineWebType === 'RADIO' || projectDefineWebType === 'CHECKBOX' || projectDefineWebType === 'SELECT') {
            const options = (typeof moduleDefineConstraintValue) == 'string' && moduleDefineConstraintValue.split("//").map(item => <Option key={item} value={item}>{item}</Option>)
            return (
                <Select
                    className="ui-input"
                    placeholder={`请选择`}
                    value={searchValue || undefined}
                    onChange={this.handleSelectChange}
                    allowClear={true}
                >
                    {options}
                </Select>
            )
        } else if (projectDefineWebType.indexOf('DATE_YEAR_MONTH') >= 0) {
            let startTime, endTime, format, showTime = null;
            if (searchValue) {
                startTime = searchValue[0];
                endTime = searchValue[1];
            }
            if (projectDefineWebType === 'DATE_YEAR_MONTH') {
                format = 'YYYY-MM';
            } else if (projectDefineWebType === 'DATE_YEAR_MONTH_DAY') {
                format = 'YYYY-MM-DD';
            } else if (projectDefineWebType === 'DATE_YEAR_MONTH_DAY_HOUR_MINUTE') {
                showTime = { format: 'HH:mm' };
                format = 'YYYY-MM-DD HH:mm';
            }
            const showValue = searchValue ? [moment(startTime, format), moment(endTime, format)] : [,];
            const dateDom = (
                <RangePicker
                    format={format}
                    showTime={showTime}
                    onChange={this.handleDatePickerChange}
                    value={showValue}
                    className={showTime && "template-filter-search"}
                />
            );
            return dateDom;
        } else if (projectDefineWebType === 'CASCADE_SELECT') {
            const { optionName } = templateType;
            return (
                <div className="against-type">
                    <Input value={optionName} placeholder='请选择' onClick={this.showTemplateTree}/>
                    {
                        optionName &&
                        <Icon
                            className="close"
                            type="close-circle"
                            onClick={this.clearTemplateType}
                        />
                    }
                </div>
            )
        }
    }

    render() {
        const { moduleDefineId, moduleDefineName } = this.state;
        return (
            <div className="form-item" key={moduleDefineId}>
                <label htmlFor="" className="ui-label">{moduleDefineName}</label>
                { this.getDom() }
                <TemplateTree ref={el => this.TemplateTreeRef = el} saveTemplateData={this.saveTemplateData} />
            </div>
        )
    }
}

export default TemplateSearch;


// WEBPACK FOOTER //
// ./src/components/execute/template/TemplateSearch.js